import { BUILD_TYPE, getBuildType } from "../../SharedPropsService";
export const removeQueryParams = (url, params) => {
    var urlParts = url.split('?');
    if (urlParts.length >= 2) {
        var baseUrl = urlParts.shift(); // Get base URL without query params
        var queryParams = urlParts.join('?').split('&'); // Get query params as an array
        var updatedParams = queryParams.filter(function (param) {
            var paramName = param.split('=')[0]; // Get parameter name
            return !params.includes(paramName); // Exclude params specified in the 'params' array
        });
        return baseUrl + (updatedParams.length > 0 ? '?' + updatedParams.join('&') : ''); // Reconstruct URL
    }
    return url;
};
export const domainCheck = (url) => {
    // ----- CANNOT INCLUDE LOCALHOST:3000 FOR PRODUCTION ---- //
    const buildType = getBuildType();
    if (buildType === BUILD_TYPE.BORROWER_PRODUCTION) {
        if (url?.includes('voltmoney.in')) {
            return true;
        }
        else {
            return false;
        }
    }
    // ----- =========================================== ---- //
    if (url?.includes('voltmoney.in')) {
        return true;
    }
    else if (url?.includes('localhost:3000') || url?.includes('localhost:8080')) {
        return true;
    }
    else {
        return false;
    }
};
export const getIframeParentDomain = () => {
    return window?.document?.referrer;
};
